<template>
  <cx-dropdown trigger="click, hover" v-if="allSiteAndList.length > 1">
    <span class="cx-link">
      <span class="cx-link__icon">
        <i class="fal fa-search"></i>
      </span>
      <span>{{$t('action.searchOnInternet')}}</span>
    </span>
    <template slot="content">
      <ul class="cx-list cx-list--vertical">
        <a class="cx-link"
          rel="noopener noreferrer" target="_blank"
          v-for="site in allSiteAndList"
          :key="site.link"
          :href="site.link">
          <span>{{$t('searchOnX.searchOnX', {x: site.name})}}</span>
        </a>
      </ul>
    </template>
  </cx-dropdown>
  <a v-else-if="allSiteAndList.length == 1"
    class="cx-link"
    rel="noopener noreferrer" target="_blank"
    :href="allSiteAndList[0].link">
    <span class="cx-link__icon">
      <i class="fal fa-search"></i>
    </span>
    <span>{{$t('searchOnX.searchOnX', {x: allSiteAndList[0].name})}}</span>
  </a>
</template>

<script>
import { LOCALE_SITE_LIST } from '@/constants/otherSearchSite';
import { mapState } from 'vuex';

export default {
  name: 'search-on-other-site-dropdown',
  uit() {
    return [
      ['action', [
        'searchOnInternet',
      ]],
      ['searchOnX', [
        'searchOnX',
        'amap', 'google',
        'amapUrl', 'googleUrl', 'googleMobileUrl'
      ]]
    ]
  },
  props: {
    nameZH: {
      type: String,
      default: ''
    },
    nameEN: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
    }),
    allSiteAndList: function() {
      let siteList = LOCALE_SITE_LIST[this.$i18n.locale] || LOCALE_SITE_LIST['en'];

      return siteList.map(site => ({
          name: this.$t(`searchOnX.${site}`),
          link: this.$t(`searchOnX.${site}${(this.isMobile && site == 'google') ? 'Mobile': ''}Url`, {
            nameZH: encodeURI(this.nameZH),
            nameEN: encodeURI(this.nameEN)
          }),
        })).filter(link => link != '')
    },
  }
}
</script>
